import { Schema as S } from "effect";

export const ListPatientsRequestSchema = S.Struct({
  // required filters
  firstname: S.optional(S.String),
  lastname: S.optional(S.String),
  patientStatus: S.optional(S.String),
  activeState: S.optional(S.Boolean),
  /** Date of birth as ISO datetime (may have time comparison issues) */
  dob: S.optional(S.String),
  /** Date of birth in KBV format (YYYY-MM-DD date only) */
  kbvDob: S.optional(S.String),
  /** Date of birth greater than (for range queries) */
  dob_gt: S.optional(S.String),
  /** Date of birth less than (for range queries) */
  dob_lt: S.optional(S.String),
  dateOfDeath: S.optional(S.String),
  dateOfInActive: S.optional(S.String),
  isDeceased: S.optional(S.Boolean),
  isInactive: S.optional(S.Boolean),
  reason: S.optional(S.String),
  patientNo: S.optional(S.String),
  socialSecurityNo: S.optional(S.String),
  birthname: S.optional(S.String),

  // sorting and pagination
  sort: S.optional(S.String),
  page: S.optional(S.Int),
  itemsPerPage: S.optional(S.Int),
  noCountLimit: S.optional(S.Union([S.Literal("true"), S.Literal("false")])),

  // creation date filters
  creationDate: S.optional(S.String),
  creationDate_lt: S.optional(S.String),
  creationDate_gt: S.optional(S.String),
});

export type ListPatientsRequest = S.Schema.Type<
  typeof ListPatientsRequestSchema
>;
